
import { defineComponent, PropType, SetupContext, computed, ref} from "vue";
import NativeClient, { TitleInfo } from "@/client/native-client";
import { PantryVirtualDataInfo, PantryVirtualData, PANTRY_SORT_TYPE, PLATE_DISPLAY_FORMAT, SEARCH_VIEW_SMALL_HEIGHT_RAITO } from "@/types/pantry";
import { DropdownList } from "@/types/search";
import PantryUtil from "@/utils/pantry-util";
import PantryListItem from "@/components/pantry/PantryListItem.vue";
import PantryDropdownList from "@/components/pantry/PantryDropdownList.vue";
import PantryListEmptyView from "@/components/pantry/PantryListEmptyView.vue";
import PantryPullToRefresh from "@/components/common/PantryPullToRefresh.vue";
import { convertRemToPx } from "@/utils/common-utils";
export default defineComponent({
  name: "PantryListView",
  components: {
    PantryListItem,
    PantryDropdownList,
    PantryListEmptyView,
    PantryPullToRefresh
  },
  props: {
    list: {
      type: Array as PropType<PantryVirtualData[]>,
      default: () => []
    },
    selectMode: {
      type: Boolean,
      default: false
    },
    sortType: {
      type: String,
      default: PANTRY_SORT_TYPE.SHORT_EXPIRED
    },
    searchMode: {
      type: Boolean,
      default: false,
      require: true
    },
    isShow: {
      type: Boolean,
      default: false,
      require: true
    },
    isRefreshEnabled: {
      type: Boolean,
      default: true,
      require: true
    }
  },
  setup(props, context: SetupContext) {
    interface HTMLElementEvent<T extends HTMLElement> extends Event {
      target: T;
    }
    const sortDropdownList: DropdownList = {
      list: [
        {
          label: "利用期限目安が短い順",
          type: PANTRY_SORT_TYPE.SHORT_EXPIRED,
          id: 0
        },
        {
          label: "入庫日が新しい順",
          type: PANTRY_SORT_TYPE.NEW_DAY,
          id: 1
        },
        {
          label: "入庫日が古い順",
          type: PANTRY_SORT_TYPE.OLD_DAY,
          id: 2
        }
      ]
    };
    const getList = () => {
      const list = Array<PantryVirtualDataInfo>();
      if (props.list == null) {
        return list;
      }
      let i = 0;
      for (const data of props.list) {
        const value = PantryUtil.getStockValue(data);
        const dataInfo = new PantryVirtualDataInfo(i, data, value);
        list.push(dataInfo);
        i++;
      }
      return list;
    };
    const selectSort = (value: string) => {
      NativeClient.sendDebugLog("PantryListView selectSort value=" + value);
      context.emit("select-sort-type", value);
    };
    const getSelectMode = () => {
      return (props.selectMode) ? "キャンセル" : "編集";
    };
    const clickSelectMode = () => {
      context.emit("list-select-mode");
    };
    const onSelectCheck = (data: PantryVirtualData, checked: boolean) => {
      context.emit("select-check", data, checked);
    };
    const onClickFood = (data: PantryVirtualData) => {
      NativeClient.sendDebugLog("PantryListView onClickFood");
      context.emit("click-food", data);
    };
    const onClickFavorite = (data: PantryVirtualData) => {
      NativeClient.sendDebugLog("PantryListView onClickFavorite");
      context.emit("click-favorite", data);
    };
    const onClickShoplist = (data: PantryVirtualData) => {
      NativeClient.sendDebugLog("PantryListView onClickShoplist");
      context.emit("click-shoplist", data);
    };
    const changeValue = (data: PantryVirtualData, value: number) => {
      NativeClient.sendDebugLog("PantryListView changeValue value=" + value);
      context.emit("change-value", data, value, false);
    };
    const refresh = () => {
      NativeClient.sendDebugLog("PantryListView refresh");
      context.emit("refresh");
    };
    const styleTop = computed(() => {
      return { 'padding-top': (!props.searchMode) ? "6rem" : "0rem" };
    });
    const styleBackground = computed(() => {
      return { 'background-color': (props.isShow) ? "#ffffff" : "#f2f2f2" };
    });
    const styleSearchModeView = computed(() => {
      let height = convertRemToPx(8.3);
      if (props.searchMode) {
        height = window.innerHeight * SEARCH_VIEW_SMALL_HEIGHT_RAITO;
      }
      return { 'height': height + "px" };
    });
    /**
     * スクロール時イベント
     */
    const onScroll = (e: HTMLElementEvent<HTMLDivElement>) => {
      // NativeClient.sendDebugLog(
      //   "PantryListView onScroll top=" +
      //     e.target.scrollTop +
      //     " height=" +
      //     e.target.offsetHeight +
      //     " total=" +
      //     (e.target.scrollTop + e.target.offsetHeight) +
      //     " scrollH=" +
      //     e.target.scrollHeight
      // );
      // データ初期化後のscrollTop=0では読み込まないようにする
      if (
        e.target.scrollTop != 0 &&
        e.target.scrollTop + e.target.offsetHeight >=
        e.target.scrollHeight - 1
      ) {
        NativeClient.sendDebugLog("PantryListView scrollEnd");
        context.emit("scroll-end");
      }
    };
    return {
      sortDropdownList,
      getList,
      selectSort,
      getSelectMode,
      clickSelectMode,
      onSelectCheck,
      onClickFood,
      onClickFavorite,
      onClickShoplist,
      changeValue,
      refresh,
      styleTop,
      styleBackground,
      styleSearchModeView,
      onScroll
    };
  }
});
